import React from 'react'
import { connect } from 'react-redux'
import { dataTypes, bindingTypes } from '@adalo/constants'
import { Field } from 'redux-form'
import classNames from 'classnames'
import { getApp } from 'ducks/apps'

import { getLabel } from 'utils/sources'
import { getParams } from 'ducks/apps/params'
import { getSources, addBindings } from 'ducks/recommender'
import { getDefaultDatasource } from 'ducks/apps/datasources'

import { WrappedBindableTextControl } from '../../../Shared/BindableTextControl'

const DeepLinkingOptions = ({
  appId,
  componentId,
  objectId,
  actionId,
  field,
  userOptions,
  getLabel,
  reference,
  options,
  menuTheme,
  app,
  ...props
}) => {
  const role = reference ? 'listItem' : null

  const { deepLinking } = app || {}
  const aliases = deepLinking?.aliases || {}
  const alias = Object.keys(aliases).find(
    key => aliases[key].componentId === componentId
  )

  const aliasParams = Object.entries(aliases[alias]?.query || {}).map(
    ([key, value]) => ({ key, value })
  )

  return (
    <div
      className={classNames(
        'action-item-form-options',
        'form-inspect-field-wrapper',
        'notifications-action-form'
      )}
    >
      {aliasParams.map(({ key, value }) => (
        <Field
          key={key}
          label={`${value.value} ID`}
          name={`${field}.options.${key}`}
          component={WrappedBindableTextControl}
          objectId={objectId}
          role={role}
          reference={reference}
          actionId={actionId}
        />
      ))}
    </div>
  )
}

const mapStateToProps = (state, props) => {
  let { appId, componentId, objectId, actionId, reference, options } = props
  const datasource = getDefaultDatasource(state, appId)
  const { auth } = datasource
  const tableId = auth.table

  const userTypes = [
    { tableId, datasourceId: datasource.id, type: dataTypes.OBJECT },
    { tableId, datasourceId: datasource.id, type: dataTypes.LIST },
  ]

  const userOptions = addBindings(
    getSources(
      state,
      appId,
      componentId,
      objectId,
      userTypes,
      false,
      actionId,
      reference
    ),
    [bindingTypes.LIBRARY_PROP]
  )

  let screenId = options && options.screenId

  if (typeof screenId === 'object') {
    appId = screenId.appId
    screenId = screenId.screenId
  }

  return {
    userOptions,
    params: getParams(state, appId, screenId),
    getLabel: source => getLabel(state, source, appId, componentId),
    app: getApp(state, appId),
  }
}

export default connect(mapStateToProps)(DeepLinkingOptions)
